export const integrationsDirectCdiJobsJobId = "/integrations/direct/cdi/jobs/:job_id";
